module.exports = __webpack_public_path__ + "img/spain.8ab50aa3.svg";